import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { auth } from "@/plugins/firebase.js";

import titleMixin from './components/mixins/titleMixin'
Vue.mixin(titleMixin)

console.log("VUE_APP_AUTH_DOMAIN is: " + process.env.VUE_APP_AUTH_DOMAIN);

import VueCoreVideoPlayer from "vue-core-video-player";
Vue.use(VueCoreVideoPlayer);


Vue.config.productionTip = false;

let app;
auth.onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }

  if (user) {
    store.dispatch("fetchUserProfile", user);
  }
  
});
